import EventListItem from "./EventListItem.vue";
export default EventListItem;